import { Column, Locales } from "@simplyk/common";
import { UseFormSetValue } from "react-hook-form";

import { useTranslateRows } from "../helpers/useTranslateRows";
import { TicketingTranslationsData } from "../translation.types";

interface PrizeTexts {
  title?: string | null;
  description?: string | null;
}

export const useTranslatePrizes = ({
  prizes,
  translationLocale,
  setValue,
}: {
  prizes: Array<{ id: string; source?: PrizeTexts; saved?: PrizeTexts }>;
  translationLocale: Locales;
  setValue: UseFormSetValue<TicketingTranslationsData>;
}) => {
  const { isTranslating, translatedIds } = useTranslateRows<TicketingTranslationsData>({
    translationLocale,
    setValue: (path, value) => setValue(path as `translations.prizesFields.${number}.title`, value),
    rows: prizes.map((prize, index) => ({
      id: prize.id,
      fields: [
        {
          key: "title",
          path: `${Column.Translations}.prizesFields.${index}.title`,
          source: prize.source?.title ?? "",
          saved: prize.saved?.title,
          isPlainText: true,
        },
        {
          key: "description",
          path: `${Column.Translations}.prizesFields.${index}.description`,
          source: prize.source?.description ?? "",
          saved: prize.saved?.description,
        },
      ],
    })),
  });

  return { isTranslatingPrizes: isTranslating, translatedPrizeIds: translatedIds };
};
